<template>
    <div>

        <div class="chat-button" @click="OpenChatWindow()" v-if="!chat_open"><img src="../assets/chat-icon.png" ><span>  {{ChatCount()}}</span> </div>
       
        <div class="chat-popup" id="myForm">
            <div class="chat-header">
                <h3>Quick Chat with Accounting Manager</h3>
                 <button type="button" class="btn cancel" @click="CloseChatWindow()"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" fill="#292c34"></path></svg></button>
            </div>
           <ul class="chat-list thin-scroll" id="chat-list" ref="messagesContainer">
               <li v-for="data in list" :key="data.key" >
                   <div class="chat-right" v-if="data.sender=='user'">

                    <span class="text">

                        <small class="msg-details">{{data.created_at | FormatDate('MM/DD/YYYY hh:mm a')}}</small>
                    {{data.message}}
                    </span> 
                    <span class="user"><img :src="current_user_name ? 'https://ui-avatars.com/api/?name='+current_user_name :'../assets/user-icon.png'" class="img-fluid"></span>   
                </div> 
                   <div class="chat-left" v-else><span class="user" v-if="data.sender=='admin'"><img src="../assets/roa_icon.png"></span><span class="text"><small class="msg-details">{{data.created_at | FormatDate('MM/DD/YYYY hh:mm a')}}</small>
                   {{data.message}}</span></div>
               </li>
           </ul>
        <div id="chat-end"></div>
        <form  class="form-container common_chat">
            <!-- <input placeholder="Type message.." name="msg" v-model="sendData.message" class="form-control" required /> -->
            <div class="send-message"> 
            <ResizableTextarea ref="resize">  
                <textarea placeholder="Type message.." ref="textarea" name="msg" v-model="sendData.message" class="form-control" required rows="1" cols="5" >  </textarea>
            </ResizableTextarea>
            <a  class="btn-send" @click="Send()"><svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="paper-plane" class="svg-inline--fa fa-paper-plane fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M440 6.5L24 246.4c-34.4 19.9-31.1 70.8 5.7 85.9L144 379.6V464c0 46.4 59.2 65.5 86.6 28.6l43.8-59.1 111.9 46.2c5.9 2.4 12.1 3.6 18.3 3.6 8.2 0 16.3-2.1 23.6-6.2 12.8-7.2 21.6-20 23.9-34.5l59.4-387.2c6.1-40.1-36.9-68.8-71.5-48.9zM192 464v-64.6l36.6 15.1L192 464zm212.6-28.7l-153.8-63.5L391 169.5c10.7-15.5-9.5-33.5-23.7-21.2L155.8 332.6 48 288 464 48l-59.4 387.3z"></path></svg></a>
            </div>
            
        </form>
        </div>
    </div>
</template>
<script>
import chat from '../services/chat'
import Pusher from 'pusher-js'
import ls from '../services/ls'
import ResizableTextarea from "./ResizableTextarea";
export default {
    name: "commaon-chat",
    components: {
        ResizableTextarea
    },
    data(){
        return{
            sendData:{
                message:'',
                sender:'user',
                source:'commaon_chat'
            },
            count:0,
            list:[],
            pusher: null,
            channel: null,
            pusherKey:process.env.VUE_APP_PUSHER_KEY,
             audio_file:process.env.VUE_APP_URL+'assets/got-it-done.mp3',
             chat_open:false,
             current_user_name:ls.get('_u_name'),
        }
    },
    methods: {
        OpenChatWindow(){
             document.getElementById("myForm").style.display = "block";
             this.chat_open = true;
              var content = this.$refs.messagesContainer;
            content.scrollTop = content.scrollHeight
            this.readChat();
        },
        CloseChatWindow(){
            document.getElementById("myForm").style.display = "none";
            this.chat_open = false;
        },
        Send(){
            this.list.push({message:this.sendData.message,sender:this.sendData.sender})
            chat.postCommonChat(this.sendData)
            .then(response =>{
                this.sendData.message ='';
                response.data
            })
            
        },
        GetChat(){
             chat.getCommonChat({'from':'common_chat'})
            .then(response=>{
               this.list=response.data.chat;
                this.count=response.data.count;
               this.ChatCount();
            })
        },
        readChat(){
             chat.readChat({'from':'common_chat'})
            .then(response=>{
               this.count=response.data.count;
               this.ChatCount();
            })
        },
          PushChat(chatData){
            var Receivedmessage = chatData.chat;
            if(ls.get('_u_unique')==Receivedmessage.to){
                this.playSound();
                this.GetChat()
                const el = document.getElementById('chat-end');
                        el.scrollIntoView({behavior: "smooth"});
                // this.list.push({message: Receivedmessage.message,sender:Receivedmessage.sender})
            }
        },
        playSound () {
            var sound =this.audio_file
            if(sound) {
                var audio = new Audio(sound);
                audio.play();
            }
        },
        ChatCount(){
            return this.count;
        }
    },
    created() {
        
       this.GetChat()
        this.pusher = new Pusher(this.pusherKey, {
                encrypted: true,
                cluster: 'ap2'
            })
            let that = this
            this.channel = this.pusher.subscribe('chats')
            this.channel.bind('common-chat-admin-update', function (data) {
                that.$emit('incoming__common_chat', data)
            })
            this.$on('incoming__common_chat', function (receivedMessage) {
               this.PushChat(receivedMessage)
            })
           
       
    }
};
</script>